export const tomiApiUrl = 'https://tomipay-staging.tomi.com/'
export const ApiUrl = 'https://wordpressbe.tomi.com/wp-json/wp/v2/'

